interface BufferLike {
    isBuffer: (obj: unknown) => boolean;
}

function _isObject(obj: unknown): obj is Record<string, unknown> {
    if (obj === undefined || obj === null || typeof obj !== 'object') {
        return false;
    }

    return true;
}

function _isBufferLike(obj: unknown): obj is BufferLike {
    if (obj === undefined || obj === null || typeof obj !== 'function') {
        return false;
    }

    const allowedProperties = Object.keys(obj);

    if (!allowedProperties.includes('isBuffer')) {
        return false;
    }

    const property = Object.getOwnPropertyDescriptor(obj, 'isBuffer');

    if (!property) {
        return false;
    }

    if (typeof property.value !== 'function') {
        return false;
    }

    return true;
}

function _bufferLike(obj: unknown): BufferLike | undefined {
    if (!_isObject(obj)) {
        return undefined;
    }

    if (!obj.constructor) {
        return undefined;
    }

    const bufferLike = obj.constructor;

    if (!_isBufferLike(bufferLike)) {
        return undefined;
    }

    return bufferLike;
}

/* Instead of including a Buffer polyfill on Browser, we only need the isBuffer, using the lines below */
function isBuffer(obj: unknown): obj is Buffer {
    const bufferLike = _bufferLike(obj);

    /* If we have a definition of Buffer.isBuffer from #obj.constructor.isBuffer, so ask it instead */
    const result = Boolean(bufferLike?.isBuffer(obj));

    return result;
}

export default Object.freeze({
    isBuffer,
});
